import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { allapiAction } from "../../../Redux/common/action";
// import { Button, Modal } from "antd";
import { Button, Modal, Table } from "react-bootstrap";
import { URL } from "../../../Redux/common/url";
const CourceChapters = () => {
  const dispatch = useDispatch();
  const router = useNavigate();
  const { id } = useParams();

  const locationv = useLocation();

  const searchParams = new URLSearchParams(locationv.search);
  const search = searchParams.get("search");
  const location = searchParams.get("location");
  const page = searchParams.get("page");

  // const { search, page, location } = useParams();
  const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  const pageno = page ? page : 1;

  const listdata = get_product_list?.proList?.docs
    ? get_product_list?.proList?.docs
    : [];
  console.log(get_product_list);
  console.log(listdata);

  useEffect(() => {
    // searchProduct

    if (search) {
      if (location) {
        dispatch(
          allapiAction.geteduAllListuserSide({
            page: pageno,
            _id: id,
            location,
          })
        );
      } else {
        dispatch(allapiAction.geteduAllListuserSide({ page: pageno, _id: id }));
      }
    } else {
      if (location) {
        dispatch(
          allapiAction.geteduAllListuserSide({
            page: pageno,
            location,
            _id: id,
          })
        );
      } else {
        dispatch(allapiAction.geteduAllListuserSide({ page: pageno, _id: id }));
      }
    }
    // dispatch(allapiAction.getfiltercategory({}));
    return () => {};
  }, [locationv.search]);
  const [show, setShow] = useState(false);
const [currentChapterIndex, setCurrentChapterIndex] = useState(() => {
  return Number(localStorage.getItem("course_progress")) || 0;
});
  const handleClose = () => setShow(false);
useEffect(() => {
  setCurrentChapterIndex(
    Number(localStorage.getItem("course_progress")) || 0
  );
}, [locationv]);
  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Buy Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <img
                className="img-fluid rounded"
                src={URL?.API_BASE_URL + get_product_list?.proLists?.image}
                alt=""
              />
              <h4>{get_product_list?.proLists?.name}</h4>
              <p>{get_product_list?.proLists?.description}</p>
              {/* Woohoo, you are reading this text in a modal! */}
            </div>
            <a
              href={
                "https://manglamart.com/product/" +
                get_product_list?.proLists?.product_id?.pro_sulg
              }
              target="_blank"
              onClick={handleClose}
            >
              Buy Now
            </a>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <a
            href={
              "https://manglamart.com/product/" +
              get_product_list?.proLists?.product_id?.pro_sulg
            }
            target="_blank"
            variant="primary"
            onClick={handleClose}
          >
            Save Changes
          </a>
        </Modal.Footer> */}
      </Modal>
      {get_product_list?.buyorder == null && (
        <div className="d-flex flex-column p-2 chapters-container">
          {listdata &&
            listdata?.map((data, i) => {
              const chapterNo2 = (pageno - 1) * 10;
              const chapterNo = chapterNo2 + (i + 1);
                let bgColor = "#dc3545";
  let textColor = "#fff";

  if (i < currentChapterIndex) {
    bgColor = "#28a745";
  } else if (i === currentChapterIndex) {
    bgColor = "#ffd700";
    textColor = "#000";
  }
              return (
                <div
                  // to={`/chapter/${data?.slug}`}
                  onClick={() => {
                    setShow(true);
                  }}
                  className="link-light text-decoration-none my-2 chapters-container-link"
                >
                  <div className="py-2 rounded chapters-container-card">
                    <div className="row">
                      <div className="col-3">
                        <img
                          className="img-fluid rounded"
                          src={URL?.API_BASE_URL + data?.thumbnail}
                          alt=""
                        />
                      </div>
                      <div className="col-9">
                        Chapter {chapterNo}:<br /> {data?.name}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
{get_product_list?.buyorder !== null && (
  <div className="d-flex flex-column p-2 chapters-container">
    {listdata &&
      listdata.map((data, i) => {
        const chapterNo2 = (pageno - 1) * 10;
        const chapterNo = chapterNo2 + (i + 1);

        let bgColor = "#dc3545";
        let textColor = "#fff";
        let icon = "🔒";

        if (i < currentChapterIndex) {
          bgColor = "#28a745";
          icon = "✅";
        } else if (i === currentChapterIndex) {
          bgColor = "#ffd700";
          textColor = "#000";
          icon = "▶️";
        }

       return (
  <div
    key={i}
    className="text-decoration-none my-2 chapters-container-link"
    onClick={() => {
      if (i <= currentChapterIndex) {
        router(`/chapter/${data?.slug}`);
      }
    }}
    style={{
      cursor: i <= currentChapterIndex ? "pointer" : "not-allowed"
    }}
  >
    <div
      className="py-2 rounded chapters-container-card"
      style={{
        backgroundColor: bgColor,
        color: textColor,
        padding: "12px",
        fontWeight: "600"
      }}
    >
      <div className="d-flex justify-content-between">
        <span>
          Chapter {chapterNo}: {data?.name}
        </span>
        <span>{icon}</span>
      </div>
    </div>
  </div>
);
      })}
  </div>
)}
    </div>
  );
};

export default CourceChapters;
